import React from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { RiseUserActionStudentStatusEnum } from "@/__generated__/types";
import { Select, SelectItem, SelectContent } from "@/components/ui";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ChevronDownIcon } from "lucide-react";
import { Spinner } from "@/components/ui/Spinner";

export const StatusDropdown = ({
  value,
  onChange,
  loading = false,
}: {
  value: RiseUserActionStudentStatusEnum;
  onChange: (status: RiseUserActionStudentStatusEnum) => void;
  loading?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Select onValueChange={onChange} value={value}>
      <SelectPrimitive.Trigger
        data-slot="select-trigger"
        data-size={"default"}
        disabled={loading}
        className={cn(
          "flex w-fit items-center justify-between gap-2 rounded-md border border-1 border-input bg-white text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[placeholder]:text-muted-foreground data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        )}
      >
        <div
          className={cn(
            "min-w-[86px] px-3 py-2 text-left",
            loading && "flex justify-center",
          )}
        >
          {loading ? (
            <Spinner />
          ) : (
            t(`riseActionDetails.studentStatuses.${value}`)
          )}
        </div>
        <div className="-mt-4 -mb-4 h-full w-[1px] bg-border"></div>
        <div className="py-2 pr-3">
          <SelectPrimitive.Icon asChild>
            <ChevronDownIcon className="size-4 opacity-50" />
          </SelectPrimitive.Icon>
        </div>
      </SelectPrimitive.Trigger>
      <SelectContent>
        {Object.values(RiseUserActionStudentStatusEnum).map((status) => {
          return (
            <SelectItem key={status} value={status}>
              {t(`riseActionDetails.studentStatuses.${status}`)}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
